<template>
  <div>
    <h3 class="greenTitle">Centro de distribución</h3>
    <div class="firstStep">
      <el-form>
        <el-form-item label="EMPRESA">
          <el-select  v-model="stepData.enterprises_id"
                      placeholder="Ej: Transportes Atenas"
                      filterable
                      :multiple = true
                      :multiple-limit = 1
                      clearable>
            <el-option  v-for="enterprises in data.enterprises_id"
                        :key="enterprises.id"
                        :label="enterprises.name"
                        :value="enterprises.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="CT">
          <el-select  v-model="stepData.distribution_centers_id"
                      placeholder="Ej: Tradis"
                      filterable
                      :multiple = true
                      :multiple-limit = 1
                      clearable>
            <el-option  v-for="ct in data.cts"
                        :key="ct.id"
                        :label="ct.name"
                        :value="ct.id"/>
          </el-select>
        </el-form-item>
        <div class="datePicker">
          <span class="label">Fecha planificación</span>
          <el-date-picker @change="setTimeFormat()"
                          ref="planningDate"
                          v-model="date"
                          value-format="yyyy-MM-dd"
                          format="dd-MM-yyyy"
                          placeholder="Fecha"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="timePickerStyle">
          <div class="timePicker">
            <span class="label">Horario inicio</span>
            <el-time-picker @change="setTimeFormat()"
                            format="HH:mm"
                            value-format="HH:mm"
                            v-model="timeInit"
                            placeholder="09:00"
                            :picker-options="{
                              start: '09:00',
                              step: '01:00',
                              end: '09:00'}">
            </el-time-picker>
          </div>
          <div class="timePicker">
            <span class="label">Horario término</span>
            <el-time-picker @change="setTimeFormat()"
                            format="HH:mm"
                            value-format="HH:mm"
                            v-model="timeFinish"
                            placeholder="21:00"
                            :picker-options="{
                              start: '21:00',
                              step: '01:00',
                              end: '21:00'}">
            </el-time-picker>
          </div>
        </div>
        <el-form-item label="region">
          <el-select  @change="handleResetCommune()"
                      v-model="stepData.region"
                      placeholder="Ej: Region Metropolitana"
                      filterable
                      clearable>
            <el-option  v-for="region in data.regions"
                        :key="region.id"
                        :label="region.name"
                        :value="region.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="comuna/s">
          <el-select  v-model="stepData.communes_id"
                      placeholder="Ej: Puente Alto"
                      :disabled="!data.communes.length"
                      multiple
                      filterable
                      clearable>
            <el-option  v-for="commune in data.communes"
                        :key="commune.id"
                        :label="commune.name"
                        :value="commune.id"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="buttonsContainer">
      <el-button  class="default"
                  @click="handleNextStep()">
                  SIGUIENTE
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { cachedAPIRequest } from '../../mixins/cacheDim';

export default {
  props: {
    stepData: {
      type: Object,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(Date.now() - 86400000);
        },
      },
      date: '',
      timeInit: moment(new Date(2016, 9, 10, 9, 0)).format('HH:mm'),
      timeFinish: moment(new Date(2016, 9, 10, 21, 0)).format('HH:mm'),
      data: {
        enterprises_id: [],
        regions: [],
        communes: [],
        cts: [],
      },
      dataToCheck: {
        enterprises_id: [],
        distribution_centers_id: [],
        time_init: '',
        time_finish: '',
        communes_id: [],
      },
      fullStepData: {
        config: {
          enterprises_id: [],
          enterprises_name: [],
          distribution_centers_id: [],
          distribution_centers_name: [],
          region: 0,
          region_name: '',
          communes_id: [],
          communes_name: [],
          time_init: '',
          time_finish: '',
        },
      },
    };
  },
  methods: {
    dateFocus() {
      this.$refs.planningDate.focus();
    },
    setDataToCheck() {
      // TODO: Revisar
      this.dataToCheck.time_init = this.timeInit;
      this.dataToCheck.time_finish = this.timeFinish;
      const thisStepData = this.stepData;
      this.dataToCheck.enterprises_id.length = 0;
      thisStepData.enterprises_id.forEach((chosenEnterprises) => {
        const equalEnterprises = this.data.enterprises_id
          .find(element => element.id === chosenEnterprises);
        this.dataToCheck.enterprises_id.push(equalEnterprises.name);
        this.fullStepData.config.enterprises_id.push(equalEnterprises.id);
        this.fullStepData.config.enterprises_name.push(equalEnterprises.name);
      });
      this.dataToCheck.distribution_centers_id.length = 0;
      thisStepData.distribution_centers_id.forEach((chosenCD) => {
        const equalCD = this.data.cts.find(element => element.id === chosenCD);
        this.dataToCheck.distribution_centers_id.push(equalCD.name);
        this.fullStepData.config.distribution_centers_id.push(equalCD.id);
        this.fullStepData.config.distribution_centers_name.push(equalCD.name);
      });
      // this.dataToCheck.communes_id.length = 0;
      const equalRegions = this.data.regions.find(element => element.id === thisStepData.region);
      this.fullStepData.config.region = equalRegions.id;
      this.fullStepData.config.region_name = equalRegions.name;

      this.dataToCheck.communes_id.length = 0;
      thisStepData.communes_id.forEach((chosenCommune) => {
        const equalCommune = this.data.communes.find(element => element.id === chosenCommune);
        this.dataToCheck.communes_id.push(equalCommune.name);
        this.fullStepData.config.communes_id.push(equalCommune.id);
        this.fullStepData.config.communes_name.push(equalCommune.name);
      });
    },
    setTimeFormat() {
      this.stepData.time_init = moment(`${this.date}T${this.timeInit}`).toISOString();
      this.stepData.time_finish = moment(`${this.date}T${this.timeFinish}`).toISOString();
      this.fullStepData.config.time_init = this.stepData.time_init;
      this.fullStepData.config.time_finish = this.stepData.time_finish;
    },
    handleResetCommune() {
      this.stepData.communes_id.length = 0;
    },
    handleNextStep() {
      this.setDataToCheck();
      const dataToCheck = this.stepData;
      if (dataToCheck.distribution_centers_id.length > 0
        && dataToCheck.region !== ''
        && dataToCheck.communes_id.length > 0
        && this.timeFinish !== ''
        && this.timeInit !== ''
        && this.date !== '') {
        this.$emit('step', 1);
        this.$emit('handleDataListToCheck', this.dataToCheck, this.fullStepData);
      } else {
        this.$notify.warning({
          title: '¡Advertencia!',
          message: 'Dejar campos vacíos puede afectar la planificación',
        });
      }
    },
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: {
          limit: 6000,
        },
      }).then((result) => {
        this.data.enterprises_id = result.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        });
      });
    },
    getRegions() {
      cachedAPIRequest({
        module: 'planning',
        service: 'regions',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.regions = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'No se pudo cargar las regiones',
        });
      });
    },
    getCommunes(regions = {}) {
      cachedAPIRequest({
        module: 'planning',
        service: 'communes',
        params: { limit: 2500, communes_regions_id: regions.communes_regions_id },
      }).then((data) => {
        this.data.communes = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'No se pudo cargar las comunas',
        });
      });
    },
    getDistributionCenters() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.cts = data.data;
        const i = this.data.cts.findIndex(ct => ct.id === 8000);
        this.data.cts.splice(i, 1);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'No se pudo cargar los CT',
        });
      });
    },
  },
  beforeMount() {
    this.getEnterprises();
    this.getRegions();
    this.getDistributionCenters();
    if (this.stepData.region) {
      this.getCommunes({
        communes_regions_id: this.stepData.region,
        limit: 2500,
      });
    }
  },
  watch: {
    'stepData.region': function watch(nValue) {
      if (nValue) {
        this.getCommunes({
          communes_regions_id: nValue,
          limit: 2500,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.stepsMaxWidth {
  max-width: 90%;
}
.stepContainerStyle {
  // max-height: 600px;
  // overflow: scroll;
  width: 90%;
  border: 1px solid #E0E0E0;
  border-radius: 3px;
  margin-top: 1em;
  padding: 1.5em;
  box-sizing: border-box;
}
.datePicker {
  margin-bottom: 22px;
}
.timePickerStyle {
  display: flex;
  width: 100%;
  margin-bottom: 22px;
  justify-content: space-between;
  .timePicker {
    width: 48.5%;
  }
}
.buttonsContainer {
  display: flex;
  justify-content: flex-end;
}
.el-form {
  display: flex;
  flex-direction: column;
}
.el-form-item {
  position: relative;
}
.label {
  text-transform: uppercase;
  font-size: 10px;
  color: #606266;
  margin-bottom: 8px;
}
.greenTitle {
  font-size: 15px;
  color: #AAD500;
  margin: 0;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.greySubTitle {
  color: #707070;
  font-weight: 300;
  text-align: left;
  font-size: 14px;
  margin: 0 0 1em;
}
</style>
